import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import data from "../Data.json";
import Form from "./Form";

function ProductDetails() {
  const { id } = useParams();
  const oneProduct = data.find((item) => item.id === Number(id));
  const [selectedValues, setSelectedValues] = useState([]);
  // const [textInputValue, setTextInputValue] = useState(""); // Add useState for the input value

  // const handleTextInputChange = (e, groupName) => {
  //   setTextInputValue(e.target.value);
  //   handleRadioChange(groupName, e.target.value);
  // };
  const renderOptions = (options, groupName) => {
    const renderRegularOptions = (optionsArray) => {
      if (!optionsArray || optionsArray.length === 0) {
        return null;
      }

      return optionsArray.map((option, index) => (
        <li key={index} className="space-x-2 uppercase">
          <input
            type="radio"
            name={groupName}
            value={option}
            id={option}
            onChange={() => handleRadioChange(groupName, option)}
          />
          <label htmlFor={option}>{option}</label>
          {(selectedValues.some(
            (value) =>
              value.value === "other" ||
              value.value === "width" ||
              value.value === "height" ||
              value.value === "length"
          ) &&
            option === "width") ||
          option === "width" ||
          option === "other" ||
          option === "length" ||
          option === "height" ? (
            <input
              type="text"
              className="border-b-2 border-black focus:outline-none"
              name={groupName}
              placeholder="Enter here"
              id={`${option}-text-input`}
              // value={textInputValue} // Set the input value from state
              onInput={(e) => handleRadioChange(groupName, e.target.value)} // Pass 'groupName' as an argument
            />
          ) : (
            <input type="hidden" />
          )}
        </li>
      ));
    };

    if (options.hasOwnProperty("heading")) {
      return (
        <div key={groupName}>
          <h3 className="text-2xl uppercase font-medium pb-2">
            {options["heading"][0]}
          </h3>

          <ul>{renderRegularOptions(options[options])}</ul>
        </div>
      );
    } else if (Array.isArray(options)) {
      return renderRegularOptions(options);
    } else if (typeof options === "object") {
      if ("Note" in options) {
        return (
          <div key={groupName}>
            <ul className="pb-4">{renderRegularOptions(options["Options"])}</ul>
            <div className="w-1/2">
              <p>Note:</p>
              <i className="font-medium capitalize">{options["Note"]}</i>
            </div>
          </div>
        );
      } else {
        return Object.entries(options).map(([subcategory, subOptions]) => (
          <div key={subcategory}>
            <details className="pb-3">
              <summary className="text-xl capitalize font-medium">
                {subcategory}
              </summary>
              <ul>{renderOptions(subOptions, groupName)}</ul>
            </details>
          </div>
        ));
      }
    } else {
      return renderRegularOptions([options]);
    }
  };

  const handleRadioChange = (groupName, selectedOption) => {
    const selectedValuesCopy = [...selectedValues];
    const index = selectedValuesCopy.findIndex(
      (value) => value.group === groupName
    );
    if (index !== -1) {
      selectedValuesCopy[index] = { group: groupName, value: selectedOption };
    } else {
      selectedValuesCopy.push({ group: groupName, value: selectedOption });
    }
    setSelectedValues(selectedValuesCopy);
  };

  return (
    <div className="overflow-x-hidden xl:px-32 lg:px-24 md:px-16 px-10 ">
      <div className="mx-auto w-full py-8 h-auto flex flex-col ">
        <div className="flex  md:py-12 md:px-12  md:shadow-md shadow-gray-400 rounded-sm justify-between items-start">
          <div className="sm:flex sm:space-x-4  space-y-4 sm:space-y-0">
            <div className="bg-white ">
              <div className="sm:w-40    ">
                <img
                  title={oneProduct.title}
                  alt="AXC7610-10000S"
                  className="object-cover h-full w-full"
                  src={oneProduct.img}
                />
              </div>
            </div>
            <div className="md:w-1/2">
              <span className="font-medium lg:text-4xl md:text-3xl text-2xl ">
                {oneProduct.title}
              </span>
              <div className="opacity-70">
                <p className="py-2">{oneProduct.body}</p>
                <p>{oneProduct.disc}</p>
              </div>
            </div>
          </div>
          <div className="back_btn sm:block hidden">
            <Link to="/shop">
              <i class="fa-solid fa-xmark text-xl "></i>
            </Link>
          </div>
        </div>
        <div className="py-12 grid md:grid-cols-2 grid-cols-1">
          <div className="">
            <h2 className="lg:text-2xl text-xl pb-4 font-medium">
              SELECT YOUR REQUIRED OPTIONS
            </h2>

            {Object.entries(oneProduct.catagery).map(([category, options]) => (
              <div key={category}>
                <ul>{renderOptions(options, category)}</ul>
              </div>
            ))}

            <div className="opacity-60">
              <p>Your selected Options</p>
              <ul>
                {selectedValues.length === 0 ? (
                  <li className="capitalize text-sm">Not Selected yet</li>
                ) : (
                  selectedValues.map((value, index) => (
                    <li className="capitalize text-sm" key={index}>{`${
                      index + 1
                    }:  ${value.value}`}</li>
                  ))
                )}
              </ul>
            </div>
          </div>
          <form
            action="https://formsubmit.co/mafaqsaad51@gmail.com"
            method="POST"
            encType="multipart/form-data"
          >
            <div className="form_inputs flex flex-col w-full space-y-2 text-sm">
              <Form />
              <input type="hidden" name="title" value={oneProduct.title} />
              <input
                className=""
                type="hidden"
                placeholder=""
                name="order details"
                value={selectedValues
                  .map((value) => `${value.group}: ${value.value}`)
                  .join(", ")}
              />
              <input type="file" multiple="multiple" name="file" id="" />
              <input
                type="hidden"
                name="_subject"
                value="mail from keylinesolution  "
              />
              <input
                type="hidden"
                name="_autoresponse"
                value="Your order is successfully placed we will contact you soon"
              />
              <input
                type="hidden"
                name="_next"
                value={`https://wa.ms/923010112600/?text=I want to order *${oneProduct.title}* what is the estimated price with these specific details `}
              />
            </div>

            <button
              type="submit"
              className="border-2 w-full border-black text-sm hover:text-black py-2 px-8 bg-black hover:bg-transparent text-white transition-all mt-4"
            >
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ProductDetails;
